// MIT License - Copyright (c) 2026 Doug McNall - See .kiro/steering/general/development-standards.md for full license

/**
 * Universe Mario World - Main Export
 * 
 * Aggregates all configuration for the Mario World universe.
 * A universe of pipes, power-ups, and princesses where gravity is optional.
 */

import { starSystems, starPositions } from './StarSystemsConfig';
import { warpGates, warpGatePositions } from './WarpGatesConfig';
import { MarioWorldAliensPlanets } from './AliensConfig';

export const universeMarioWorld = {
  id: 'marioworld',
  starSystems,
  starPositions,
  warpGates,
  warpGatePositions,
  aliens: MarioWorldAliensPlanets,
};

export default universeMarioWorld;